<div class="d-flex justify-content-end">
  <img class="m-3 c-pointer" src="assets/icons/close-blue.svg" (click)="activeModal.close('Cross click')">
</div>
<div class="evisa-container d-flex justify-content-center py-9 pt-1 mx-lg-5">
  <div class=" mx-3 mx-sm-0 evisa-content">
    <div class="px-6 py-6">
      <p class="fs-25 fw-400 mb-3">{{"CREATE_VISA.CIVIL_ID_INFO.REGISTER_MOBILE_ID.INSTRUCTION_LABEL" | translate }}
      </p>
      <img class="w-100 mb-6"
        [src]="this.translateService.currentLang === 'ar' ? 'assets/images/Flyer_Ar.png' :  'assets/images/Flyer_Eng.png'"
        alt="flyer">
      <p class="fs-25 fw-400 mb-3 text-center">{{'CREATE_VISA.CIVIL_ID_INFO.REGISTER_MOBILE_ID.SUPPORT_LABEL'| translate
        }}</p>
      <div class="d-flex justify-content-center">
        <button (click)="openUrl()" class="btn-1 btn btn-primary px-6 px-sm-6 fs-20 fw-400"><img
            src="assets/images/paci_logo.png">{{'CREATE_VISA.CIVIL_ID_INFO.REGISTER_MOBILE_ID.BUTTON_LABEL'| translate
          }}</button>
      </div>
    </div>
  </div>
</div>